import { useQuery } from '@tanstack/react-query';
import { tokenManager } from '../api/tokenManager';
import { getAllZones } from '../service/zones';


export const useZones = () => {
  const isAuthenticated = !!tokenManager.get('accessToken');

  return useQuery({
    queryKey: ['zones'],
    queryFn: getAllZones,
    enabled: isAuthenticated,
  });
};
